import { RootState } from '@/redux-store';
import { EmployeeWhole } from '@/types';

export const selectEmployeesData = (state: RootState) => state.reducer.employees.data;

export const selectEmployeeById = (id: EmployeeWhole['id']) => (state: RootState) => state.reducer.employees.data[id];
